import { createStyles, makeStyles, Theme } from '@bb-ui/react-library';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageTitleContainer: {
      marginBottom: theme.spacing(4),
      display: 'flex',
      justifyContent: 'flex-end',
    },
    loadMoreButton: {
      marginTop: '1rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    controlsRow: {
      display: 'flex',
      alignItems: 'flex-end',
      marginBottom: '8px',
    },
    tableWrapper: {
      position: 'relative' as 'relative',
    },
    loadingOverlay: {
      position: 'absolute' as 'absolute',
      inset: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1,
    },
  }),
);
